import usePenetrationReportV2Store from '../../stores/penetrationReportV2Store';
import MonthYearPicker from './MonthYearPicker';

function ComparisonBar() {
  const asOfPeriod = usePenetrationReportV2Store((s) => s.asOfPeriod);
  const comparePeriod = usePenetrationReportV2Store((s) => s.comparePeriod);
  const comparisonEnabled = usePenetrationReportV2Store((s) => s.comparisonEnabled);
  const setAsOfPeriod = usePenetrationReportV2Store((s) => s.setAsOfPeriod);
  const setComparePeriod = usePenetrationReportV2Store((s) => s.setComparePeriod);
  const setComparisonEnabled = usePenetrationReportV2Store((s) => s.setComparisonEnabled);

  return (
    <section className="pr2-comparison">
      <div className="pr2-compare-title">
        <span className="pr2-compare-icon" aria-hidden="true">◷</span>
        <div>
          <strong>Time comparison</strong>
          <small>Applied to the entire dashboard</small>
        </div>
      </div>
      <div className="pr2-compare-controls">
        <MonthYearPicker label="As of" period={asOfPeriod} onChange={setAsOfPeriod} />
        {comparisonEnabled && (
          <>
            <span className="pr2-versus">vs</span>
            <MonthYearPicker label="Compare with" period={comparePeriod} onChange={setComparePeriod} />
          </>
        )}
        <button
          type="button"
          className={`pr2-toggle ${comparisonEnabled ? '' : 'off'}`}
          onClick={() => setComparisonEnabled(!comparisonEnabled)}
        >
          {comparisonEnabled ? 'Comparison on' : 'Comparison off'}
        </button>
      </div>
    </section>
  );
}

export default ComparisonBar;
